import type { CardHooks } from "./registry";

/**
 * Added Pressure — Reaction Utility.
 *
 * Triggered effect handled directly inside `playUtility` (in playtestEngine.ts):
 * after the opponent plays a defend, the player may play this to apply −2
 * block to that defend. The hook here is intentionally empty — a registry
 * entry is kept so the card name is recognised, but `playUtility` already
 * surfaces the precondition + applies the −2 override.
 */
export const addedPressure: CardHooks = {};
